import HomeView from '@/views/newIndex.vue'
import { createPageApp } from '@/multi/createPageApp'

createPageApp({
  pageName: 'newIndex',
  component: HomeView
})
